export default "__VITE_ASSET__Cl6xMjQE__"